import React from 'react';
import { useTranslator } from 'tradera/lang/translate';
import { ProfileDetails } from './profile-details';
import { ProfileHeaderNav } from './profile-header-nav';
import { LocalLoader } from 'tradera/components/loader/loader';
import { Button } from 'tradera/components/atoms/button/button';
import styles from './profile-header.module.scss';

const ProfileHeader = ({ isLoading, isRejected, profileData, retryFetch }) => {
    const { t } = useTranslator();
    const { hasShop, heroImages, alias } = profileData;

    if (isRejected) {
        return (
            <div className="container">
                <div
                    className="alert alert-danger d-flex align-items-center justify-content-between"
                    role="alert">
                    {t('profileHeader_fetch_error')}
                    <Button theme="light" className="ml-1" onClick={retryFetch}>
                        {t('profileHeader_fetch_retry')}
                    </Button>
                </div>
                <ProfileHeaderNav hasShop={hasShop} />
            </div>
        );
    }

    if (isLoading || !profileData?.alias) {
        return (
            <div className="position-relative" style={{ minHeight: '27rem' }}>
                <LocalLoader />
            </div>
        );
    }

    return (
        <div className="mt-md-3">
            <div className="container d-md-flex mb-3">
                {heroImages?.max ? (
                    <ProfileImage alias={alias} images={heroImages} />
                ) : null}
                <ProfileDetails profileData={profileData} />
            </div>
            <ProfileHeaderNav hasShop={hasShop} />
        </div>
    );
};

const ProfileImage = ({ alias, images }) => {
    return (
        <div className="mx-n2 mx-md-0 mb-md-2">
            <div className={styles.profileImage}>
                <img
                    srcSet={`${images.max} 800w, ${images.med} 650w, ${images.min} 425w`}
                    sizes="(max-width: 767px) 100vw, 260px"
                    src={images.max}
                    alt={alias}
                />
            </div>
        </div>
    );
};

export { ProfileHeader };
